module.exports = __webpack_public_path__ + "static/media/Climatizacion.705de4c9.jpg";